<template>
    <div class="sounds button" :class="{'sounds--active': sound }" @click="setSound">
        <div class="sounds__icon">
            <icon name="sound" size="20px" v-if="sound == true" />
            <icon name="noSound" size="20px" v-if="sound == false" />
        </div>
        <div class="button__label" v-if="sound == true">{{resource('soundOn')}}</div>
        <div class="button__label" v-if="sound == false">{{resource('soundOff')}}</div>
    </div>
</template>

<style lang="scss">
.sounds {
  &__icon {
    display: flex;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background: $error;
    color: #fff;
  }
  .button__label{
	  margin-left: $component;
  }
  &--active .sounds__icon {
    background: $ok;
  }
}
</style>

<script>
export default {
	name: 'sound',
	methods: {
		resource(item){
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		setSound(){
			this.sound = !this.sound
			this.$store.commit('sound', this.sound)
		}
	},
	created(){
		if(window.localStorage.sound === undefined) {
			this.sound = true
			this.$store.commit('sound', this.sound)
		} else {
			this.sound = window.localStorage.sound === 'true'
		}
	},
	data() {
		return {
			sound: false,
			res:{
				nl:{
					soundOn: 'Geluid aan',
					soundOff: 'Geluid uit'
				},
				fr:{
					soundOn: 'Sound on',
					soundOff: 'Sound off'
				}
			}
		}
	}
}
</script>
